import { OSKThemeType } from 'oskcomponents';
import { Geometry, GeometryCollection, OSKGeoJson, OSKScene } from 'oskcore';
import React, { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useTheme } from 'styled-components';

type SceneFootprintsProps = {
    /** The scenes to render footprints for */
    scenes: OSKScene[];
};

const SceneFootprints = ({ scenes }: SceneFootprintsProps) => {
    const map = useMap();

    const theme = useTheme() as OSKThemeType;
    const footprintsLayer = useRef<L.LayerGroup>();
    const footprints = useRef<Record<string, L.Polygon>>({});

    useEffect(() => {
        if (footprintsLayer.current) {
            footprintsLayer.current.clearLayers();
            map.removeLayer(footprintsLayer.current);
        }

        footprintsLayer.current = L.layerGroup();
        footprintsLayer.current.addTo(map);

        map.createPane('footprints');

        [...(scenes ?? [])].forEach((scene) => {
            if (scene.geometry && 'coordinates' in scene.geometry) {
                const points = OSKGeoJson.fromAPIGeometry(
                    scene.geometry as Geometry | GeometryCollection,
                ).toLeafletCoordinates();

                let area: any = {};
                switch (scene.geometry.type) {
                    case 'Point':
                        area = L.marker(points[0], { interactive: true, pane: 'footprints' });
                        break;

                    default:
                        area = L.polygon(points, {
                            color: theme.colors.cyan1a,
                            interactive: true,
                            pane: 'footprints',
                        });
                        break;
                }

                footprints.current[scene.id] = area;
                // @ts-ignore
                footprintsLayer.current.addLayer(area);
            }
        });
    }, [scenes]);

    return <></>;
};

export default SceneFootprints;
export type { SceneFootprintsProps };
